import {Alert, Form, Spin} from 'antd';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import styles from '../../../features/empresas/styles.less';

function MiniForm({children, form, labelFlex, loading, onFinish}) {
  const [error, setError] = useState(false);

  const handleFinish = values => {
    setError(false);
    if (typeof onFinish === 'function') {
      const result = onFinish(values);
      if (result instanceof Promise)
        result.catch(err => setError(err.message));
    }
  };

  return (
      <Spin spinning={loading}>
        <Form
            form={form}
            labelCol={{flex: labelFlex}}
            wrapperCol={{flex: '1'}}
            onFinish={handleFinish}
        >
          {error &&
          <Alert showIcon message={error} type="error" className={styles['alert']} />
          }
          {children}
        </Form>
      </Spin>
  );
}

MiniForm.propTypes = {
  children: PropTypes.node,
  form: PropTypes.object,
  labelFlex: PropTypes.string,
  loading: PropTypes.bool,
  onFinish: PropTypes.func,
};

export default MiniForm;
